import $ from 'jquery'
import {apiServerOrigin} from "@/config/constants";

$.ajaxSetup({
    xhrFields: {
        withCredentials: true
    }
});

const buildRequestURL = function (p) {
    return apiServerOrigin + p;
};


function searchDocuments(q, start, size, get_global_document_ids_only) {
    return $.get(buildRequestURL('/documents'), {
        q: q,
        start: start,
        size: size,
        get_global_document_ids_only,
    })
}

function openDocument(global_document_id, edit_token, force_enter) {
    return $.post(buildRequestURL('/document/_open'), {
        global_document_id,
        edit_token,
        force_enter,
    })
}

function getSuggestedEntities(q, size, entity_type, get_all_entity_info) {
    return $.get(buildRequestURL('/suggested_entities'), {
        q,
        size,
        entity_type,
        get_all_entity_info,
    })
}

function getEntity(entity_id) {
    return $.get(buildRequestURL('/entity_detail'), {
        id: entity_id
    })
}

function createSerial(project_id) {
    return $.post(buildRequestURL('/serial/_create'), {project_id})
}

function bindDocumentToSerial(global_document_id, serial_id) {
    return $.post(buildRequestURL('/serial/_bind_doc'), {global_document_id, serial_id})
}

function unbindSerialFromGlobalDocument(serial_id, global_document_id) {
    return $.post(buildRequestURL('/serial/_unbind_from_gd'), {serial_id, global_document_id})
}

function submitDocumentChanges(globalDocumentId, detail, edit_token) {
    return $.post(buildRequestURL('/document/_save_changes'), {
        global_document_id: globalDocumentId,
        detail: JSON.stringify(detail),
        edit_token,
    })
}

function getUserInfo() {
    return $.get(buildRequestURL('/user/_info'))
}

function doUserLogin(username, password) {
    return $.post(buildRequestURL('/user/_login'), {username, password})
}

function doUserLogout() {
    return $.post(buildRequestURL('/user/_logout'))
}

function getSerialBoostList(global_document_id) {
    return $.get(buildRequestURL('/serial/_boost_list'), {global_document_id})
}

function getSerialBasicAndBoundDocuments(serial_id) {
    return $.get(buildRequestURL('/serial/_basic_and_bound_documents'), {serial_id})
}

function deleteSerial(serial_id) {
    return $.post(buildRequestURL('/serial/_delete'), {serial_id})
}

function closeDocument(global_document_id, edit_token) {
    return $.post(buildRequestURL('/document/_close'), {global_document_id, edit_token})
}

function getProjectsStatistics() {
    return $.get(buildRequestURL('/projects/_statistics'))
}

function getUserList() {
    return $.get(buildRequestURL('/lib/_user_list'))
}

function exportSelectedData(globalDocumentIds) {
    return $.post(buildRequestURL('/manager/_export_data'), {
        globalDocumentIds,
    })
}

const getFullUsersRoles = function () {
    return $.get(buildRequestURL('/manager/_users_roles'))
}

const setUserAsManager = function (username, is_manager) {
    return $.post(buildRequestURL('/manager/_set_user_as_manager'), {username, is_manager})
};

const setUserAccessToProjects = function (username, access_to_all_projects, accessible_projects) {
    return $.post(buildRequestURL('/manager/_set_user_access_to_projects'), {
        username,
        accessData: JSON.stringify({
            access_to_all_projects,
            accessible_projects,
        })
    })
}

function getProductivity(time_range) {
    return $.get(buildRequestURL('/manager/_productivity'), {time_range})
}

function getPersonCapacityData(index_id, person_id) {
    return $.get(buildRequestURL('/get_kb_capacity_data'), {
        index_id,
        person_id,
    })
}

function getPersonBioData(index_id, person_id) {
    return $.get(buildRequestURL('/get_kb_person_bio_data'), {
        index_id,
        person_id,
    })
}

function addDocumentsIntoProject(project_id, file_ids) {
    return $.post(buildRequestURL('/documents/_add'), {
        project_id,
        file_ids,
    })
}

export {
    searchDocuments,
    openDocument,
    getSuggestedEntities,
    createSerial,
    bindDocumentToSerial,
    unbindSerialFromGlobalDocument,
    submitDocumentChanges,
    getUserInfo,
    doUserLogin,
    doUserLogout,
    getSerialBoostList,
    getSerialBasicAndBoundDocuments,
    deleteSerial,
    closeDocument,
    getProjectsStatistics,
    getUserList,
    exportSelectedData,
    getFullUsersRoles,
    setUserAsManager,
    getProductivity,
    buildRequestURL,
    getPersonCapacityData,
    getPersonBioData,
    setUserAccessToProjects,
    addDocumentsIntoProject,
    getEntity
}
